import { FirstScreen } from "components/ui/FirstScreen/FirstScreen"
import { NewPassword } from "./layout/NewPassword/NewPassword"

export const PageResetPassword = () => {
	return (
		<FirstScreen>
			<div>
				<NewPassword />
			</div>
		</FirstScreen>
	)
}
